import { render, staticRenderFns } from "./PendingConsults.vue?vue&type=template&id=70ba1982&"
import script from "./PendingConsults.vue?vue&type=script&lang=js&"
export * from "./PendingConsults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports